import globalIP from '@/GlobelIP';
import { handleDecrypt } from '@/functions';
import axios from 'axios';
import { create } from 'zustand';

interface SelectedProductsState {
  selectedItems: any[];
  handleCheckChange: (value: any, checked: boolean) => void;
  isSelectedLoading: boolean;
}
const loadFromLocalStorage = (): any[] => {
  const selectedItems = sessionStorage.getItem('selectedItems');
  return selectedItems ? JSON.parse(selectedItems) : [];
};
const saveToLocalStorage = (selectedItems: any[]): void => {
  sessionStorage.setItem('selectedItems', JSON.stringify(selectedItems));
};
const C_A_id = handleDecrypt(sessionStorage.getItem('E-C_A_id'));

const catalogueCode = handleDecrypt(sessionStorage.getItem('E-typecode'));
const CatalogLinkStatus = async status => {
  const data = await axios.put(
    `${globalIP}/api/catalogues/${handleDecrypt(sessionStorage.getItem('Cat_id'))}?populate=*`,
    {
      data: { LinkStatus: status }
    }
  );
};
export const useSelectedProducts = create<SelectedProductsState>(set => ({
  selectedItems: loadFromLocalStorage(),
  isSelectedLoading: false,
  handleCheckChange: async (value, checked, ProductCode) => {
    try {
      set(state => ({ ...state, isSelectedLoading: true }));
      const response = await axios.get(`${globalIP}/api/clientactivities/${C_A_id}?populate=*`);
      const shortlistproduct = response.data.data.attributes.shortlistproduct;

      let filterData;
      if (checked) {
        filterData = shortlistproduct.filter(item => item.productid != value);
        const updatedOpenedProductData = [
          ...filterData,
          {
            typecd: catalogueCode,
            productid: String(value),
            productcode: ProductCode
          }
        ];
        await axios.put(`${globalIP}/api/clientactivities/${C_A_id}`, {
          data: {
            shortlistproduct: updatedOpenedProductData
          }
        });
      } else {
        filterData = shortlistproduct.filter(item => item.productid != value);
        if (filterData.length) {
          CatalogLinkStatus('Selected');
        } else {
          CatalogLinkStatus('Opened');
        }
        await axios.put(`${globalIP}/api/clientactivities/${C_A_id}`, {
          data: {
            shortlistproduct: filterData
          }
        });
      }
    } catch (error) {
      console.error('Error:', error);
      set(state => ({ ...state, isSelectedLoading: false }));
    }

    set(state => {
      const updatedItems = checked
        ? [...state.selectedItems, value]
        : state.selectedItems.filter(item => item != value);
      saveToLocalStorage(updatedItems);
      return { selectedItems: updatedItems, isSelectedLoading: false };
    });
  },
  handleCleanSelectedItems: () => {
    saveToLocalStorage([]);
    set({ selectedItems: [] });
  },
  handleSelectAllIds: async (allQyeryData, allProductData) => {
    set(state => ({ ...state, isSelectedLoading: true }));
    const idsToAvoid = allQyeryData.map(item => +item.productid);
    const response = await axios.get(`${globalIP}/api/clientactivities/${C_A_id}?populate=*`);
    const shortlistproduct = response.data.data.attributes.shortlistproduct;
    let updateData = [];
    const addNewData = allProductData
      .filter(item => !idsToAvoid.includes(item.id))
      .map(item => ({ id: item.id, productcode: item.attributes.ProductCode }))
      .map(item => ({
        typecd: catalogueCode,
        productid: String(item.id),
        productcode: item.productcode
      }));
    if (!shortlistproduct.length) {
      updateData = addNewData;
    } else {
      updateData = shortlistproduct.filter(item => {
        return !addNewData.some(i => i.productid == item.productid);
      });
    }
    const { data } = await axios.put(
      `${globalIP}/api/clientactivities/${C_A_id}?populate=*`,
      {
        data: {
          shortlistproduct: updateData
        }
      },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );

    if (data.data.attributes.shortlistproduct.length) {
      set(state => {
        const updatedItems = data.data.attributes.shortlistproduct.map(item =>
          Number(item.productid)
        );
        saveToLocalStorage(updatedItems);
        return { selectedItems: updatedItems, isSelectedLoading: false };
      });
    } else {
      set(state => {
        const updatedItems = [];
        saveToLocalStorage(updatedItems);
        return { selectedItems: updatedItems, isSelectedLoading: false };
      });
    }
  }
  
}));
